export enum AutomationAction {
  POSTING_DFE = "Escriturar notas",
  MOVE_CANCELLED_DFE_TO_FOLDER = "Mover notas canceladas para pasta",
  MOVE_DFE_TO_FOLDER = "Mover notas para pasta"
}

export enum AutomationActionNumber {
  MOVE_DFE_TO_FOLDER = 0,
  MOVE_CANCELLED_DFE_TO_FOLDER = 1,
  POSTING_DFE = 2
}

export class AutomationsConfig {
  actionList() {
    return [
      {
        action: "POSTING_DFE",
        name: "Escriturar notas",
        service: 'fiscal',
        conditions: this.dfeConditionList()
      },
      // {
      //   action: "MOVE_CANCELLED_DFE_TO_FOLDER",
      //   name: "Mover notas canceladas para pasta",
      //   service: 'fiscal',
      //   conditions: []
      // },
      {
        action: "MOVE_DFE_TO_FOLDER",
        name: "Mover notas para pasta",
        service: 'fiscal',
        conditions: this.dfeConditionList()
      }
    ];
  }

  dfeConditionList() {
    return [
      {
        name: "Denegada",
        operators: { isDenied: "=" },
        inputType: "boolean"
      },
      {
        name: "Emitente - CPF/CNPJ",
        operators: { issuerCpfCnpjs: "=", notIssuerCpfCnpjs: "≠" },
        inputType: "select-participant-multiple"
      },
      {
        name: "Emitente - IE",
        operators: { issuerIes: "=", notIssuerIes: "≠" },
        inputType: "text-multiple"
      },
      {
        name: "Emitente - Produtor da empresa",
        operators: { memberIssuer: "=" },
        inputType: "boolean"
      },
      {
        name: "Destinatário - CPF/CNPJ",
        operators: { addressedCpfCnpjs: "=" },
        inputType: "select-participant-multiple"
      },
      {
        name: "Destinatário - IE",
        operators: { addressedIes: "=", notAddressedIes: "≠" },
        inputType: "text-multiple"
      },
      {
        name: "Destinatário - Produtor da empresa",
        operators: { memberAddressed: "=", },
        inputType: "boolean"
      },

      {
        name: "CFOP",
        operators: { cfops: "=", notCfops: "≠" },
        inputType: "text-multiple"
      },
      {
        name: "NCM",
        operators: { ncms: "=", notNcms: "≠" },
        inputType: "text-multiple"
      },
    ];
  }

  public allOperators = [
    "isDenied",
    "issuerCpfCnpjs",
    "notIssuerCpfCnpjs",
    "issuerIes",
    "notIssuerIes",
    "memberIssuer",
    "addressedCpfCnpjs",
    "addressedIes",
    "notAddressedIes",
    "memberAddressed",
    "cfops",
    "notCfops",
    "ncms",
    "notNcms"
  ]
}
